import { render } from "./BannerComponent.vue?vue&type=template&id=625eecc2&scoped=true"
import script from "./BannerComponent.vue?vue&type=script&lang=js"
export * from "./BannerComponent.vue?vue&type=script&lang=js"

import "./BannerComponent.vue?vue&type=style&index=0&id=625eecc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625eecc2"]])

export default __exports__